import React from 'react';
import { TouchableOpacity } from 'react-native';
import { useEntitySelection } from '@shared/api/providers/entitySelection';
import { Entity } from '@shared/data/entity/Entity';

interface Props {
  entity: Entity;
}

export function EntitySelectionOverlay({ entity }: Props) {
  const { toggleEntity } = useEntitySelection();

  const onPress = () => {
    toggleEntity(entity);
  };

  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        zIndex: 1,
      }}
    />
  );
}
